import React from 'react';
import { getActiveApps, utilityApps } from '../appRegistry';
import { ServiceCard } from './AppComponents';
import HomeDigest from './HomeDigest';
import { Link } from 'react-router-dom';
import './LandingPage.css';

function LandingPage({ user }) {
  const activeApps = getActiveApps();

  return (
    <>
      <div className="hero-section">
        <div className="hero-welcome">
          <span className="hero-greeting">👋 Welcome back!</span>
          <h1 className="hero-title">Life, Organized</h1>
        </div>
        <p className="hero-subtitle">
          Your personal hub for tracking what matters — from property investments to strength training.
        </p>
      </div>

      <HomeDigest />

      <main className="micro-apps-section" role="main" aria-label="Your micro-apps">
        <h2 className="section-title">Your Micro-Apps</h2>
        <div className="services-grid">
          {activeApps.map(app => (
            <ServiceCard key={app.id} app={app} />
          ))}
        </div>
      </main>

      {/* Utility bar— Household Groups */}
      <nav className="utility-bar" aria-label="Utility apps">
        {utilityApps.map(app => (
          <Link key={app.id} to={app.route} className="utility-link">
            <span className="utility-icon">{app.icon}</span>
            <div>
              <span className="utility-name">{app.name}</span>
              <span className="utility-desc">{app.description}</span>
            </div>
            <span className="utility-arrow">→</span>
          </Link>
        ))}
      </nav>
      
      <div className="footer">
        <p>✨ Kosmoholm — One step at a time, one goal at a time</p>
      </div>
    </>
  );
}

export default LandingPage;